var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddSibling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.71022 21 0 16.2898 0 10.5C0 4.71022 4.71022 0 10.5 0C16.2898 0 21 4.71022 21 10.5C21 16.2898 16.2898 21 10.5 21ZM10.5 1.16667C5.35364 1.16667 1.16667 5.35364 1.16667 10.5C1.16667 15.6464 5.35364 19.8333 10.5 19.8333C15.6464 19.8333 19.8333 15.6464 19.8333 10.5C19.8333 5.35364 15.6464 1.16667 10.5 1.16667Z",
    fill: "#DBDFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 11.0833H11.0832V14C11.0832 14.3222 10.8221 14.5833 10.4999 14.5833C10.1777 14.5833 9.91656 14.3222 9.91656 14V11.0833H6.99989C6.6777 11.0833 6.41656 10.8222 6.41656 10.5C6.41656 10.1778 6.6777 9.91664 6.99989 9.91664H9.91656V6.99997C9.91656 6.67778 10.1777 6.41664 10.4999 6.41664C10.8221 6.41664 11.0832 6.67778 11.0832 6.99997V9.91664H13.9999C14.3221 9.91664 14.5832 10.1778 14.5832 10.5C14.5832 10.8222 14.3221 11.0833 13.9999 11.0833Z",
    fill: "#DBDFF5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSibling);
export default __webpack_public_path__ + "static/media/addSibling.20c50d982138d467b105e6c7ef6d7030.svg";
export { ForwardRef as ReactComponent };